import { createApiClient } from "@/api";
import { type DataProviderSchema } from "@/utils";

const apiClient = createApiClient("jsonld");
const BASE_URL = "/api/vpn/data_centers";

const fetchListData = async () => {
  const response = await apiClient.GET(BASE_URL);
  const data = response.data?.["hydra:member"] ?? [];
  const total = response.data?.["hydra:totalItems"] ?? 0;

  return {
    data,
    total,
  };
};

export const dataCentersSchema: DataProviderSchema<"DataCenter", "jsonld"> = {
  list: fetchListData,
};
